/** @jsx jsx */
import React from 'react';

import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { withConsumer } from '../../../contexts';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import Modal from '../../ui/Modal';

import { Container, Column, Row } from '../../../styles/Grid';
import * as styles from './index.styles';
import DotComponent from '../../ui/DotComponent';

import sampleIcon from './sampleIcon.svg';

import InputForm from '../TalkToUs/InputForm';
import { get } from 'lodash';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
class DecisionPoint extends SafePureComponent {
  phoneNumberRef = React.createRef();

  componentDidMount() {
    // this.setState({
    //   currentAnimationId: getAmountAnimationIdFromIndex(0),
    // });
  }

  onAfterOpen = () => {
    // this.handleAnalyticsDataForCurrentStep();
  };

  onAfterClose = () => {};

  getBulletPoints = data => {
    const imgPath = get(data, 'fields.Icon.value.src', '');
    const Text = get(data, 'fields.Text.value', '');
    return (
      <li>
        <span className="icon_bullet">
          <img src={sampleIcon} alt="icon" />
          {imgPath && <Image field={data.Icon} />}
        </span>
        <span className="list_text">{Text}</span>
      </li>
    );
  };

  getCard = (haveForm, data) => {
    return (
      <Column
        css={styles.cardsectioncolumn}
        cols={{ xl: 4, lg: 12, md: 12, sm: 12 }}
      >
        <div css={styles.cardsection}>
          <div css={styles.headTitle}>
            <RichText field={data.Title} tag="h3" />
            <h3>
              <DotComponent />
            </h3>
          </div>
          {data.SelectedFeatures && (
            <ul css={[styles.bulletList, haveForm && styles.hideBulletListLG]}>
              {data.SelectedFeatures.map(item => this.getBulletPoints(item))}
            </ul>
          )}
          {haveForm ? (
            <React.Fragment>
              <div css={styles.decision_form}>
                <h4>{data.TalkToUsTitle}</h4>
                <InputForm
                  PhoneNumberWatermark={data.PhoneNumberWatermark}
                  YourNameWatermark={data.YourNameWatermark}
                  CTAText={data.CTAText}
                  PhoneNumberOptions={data.PhoneNumberOptions}
                  defaultPhoneValue={data.defaultPhoneValue}
                  PhoneNumberParameterName={data.PhoneNumberParameterName}
                  NameParameterName={data.NameParameterName}
                  SubmissionAPIURL={data.SubmissionAPIURL}
                  SuccessMessage={data.SuccessMessage}
                  ErrorMessage={data.ErrorMessage}
                  PhoneNumberRequiredErrorMessage={
                    data.PhoneNumberRequiredErrorMessage
                  }
                  PhoneNumberInvalidErrorMessage={
                    data.PhoneNumberInvalidErrorMessage
                  }
                />
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <a href={data.CTALink} css={styles.cardCTAButton}>
                {data.CTAText}
              </a>
            </React.Fragment>
          )}
        </div>
      </Column>
    );
  };

  getLeftPanel = data => {
    let title = get(data, 'Title.value', '');
    var doc = new window.DOMParser().parseFromString(title, 'text/html');
    title = doc.documentElement.textContent;

    const PhoneNumberRequiredErrorMessage = get(
      data,
      'PhoneNumberRequiredErrorMessage.value',
      '',
    );
    const PhoneNumberInvalidErrorMessage = get(
      data,
      'PhoneNumberInvalidErrorMessage.value',
      '',
    );

    const cardData = {
      ...data,
      CTALink: get(data, 'CTALink.value.href', ''),
      CTAText: get(data, 'CTAText.value', ''),
      SelectedFeatures: get(data, 'SelectedFeatures', []),
      Title: { value: title },
      TalkToUsTitle: get(data, 'TalkToUsTitle.value', ''),
      PhoneNumberWatermark: get(data, 'PhoneNumberWatermark.value', ''),
      YourNameWatermark: get(data, 'NameWatermark.value', ''),
      CTAText: get(data, 'CTAText.value', ''),
      PhoneNumberOptions: get(
        this.props,
        'fields.DecisionPointData.PhoneNumberOptions',
        [],
      ),
      defaultPhoneValue: get(data, 'DomainCountryISOCode2.value', ''),
      PhoneNumberParameterName: get(data, 'PhoneNumberParameterName.value', ''),
      NameParameterName: get(data, 'NameParameterName.value', ''),
      SubmissionAPIURL: get(data, 'CTAApiURL.value', ''),
      SuccessMessage: get(data, 'SuccessMessage.value', ''),
      ErrorMessage: get(data, 'ErrorMessage.value', ''),
      PhoneNumberRequiredErrorMessage: PhoneNumberRequiredErrorMessage,
      PhoneNumberInvalidErrorMessage: PhoneNumberInvalidErrorMessage
    };

    return this.getCard(true, cardData);
  };

  getMiddlePanel = data => {
    let title = get(data, 'Title.value', '');
    var doc = new window.DOMParser().parseFromString(title, 'text/html');
    title = doc.documentElement.textContent;

    const cardData = {
      CTALink: get(data, 'CTALink.value.href', ''),
      CTAText: get(data, 'CTAText.value', ''),
      SelectedFeatures: get(data, 'SelectedFeatures', []),
      Title: { value: title },
    };

    return this.getCard(false, cardData);
  };

  safeRender() {
    const { modalsContext, fields } = this.props;
    const { currentModal, openModal, closeModal } = modalsContext;

    const Title = get(fields, 'DecisionPointData.Title.value', '');
    const CloseButtonText = get(
      fields,
      'DecisionPointData.CloseButtonText.value',
      '',
    );

    const LeftPanel = get(fields, 'DecisionPointData.LeftPanel.fields', {});
    const MiddlePanel = get(fields, 'DecisionPointData.MiddlePanel.fields', {});
    const RightPanel = get(fields, 'DecisionPointData.RightPanel.fields', {});

    return (
      <React.Fragment>
        {/* <button onClick={() => openModal(modalIds.shopDecisionPoint, {})}>
          open modal
        </button> */}

        <Modal
          isOpen={currentModal === modalIds.shopDecisionPoint}
          // isOpen={true}
          onRequestClose={closeModal}
          onAfterOpen={this.onAfterOpen}
          onAfterClose={this.onAfterClose}
          hideDefaultCloseButton
          contentProp={styles.modalContent}
          overlayProp={styles.overlayProp}
          css={styles.modalcss}
        >
          <Container css={styles.shop_overlay_container}>
            <Row css={styles.shop_overlay_mid}>
              <Column css={styles.shop_overlay_midcolumn}>
                <div className="heading_sec_overlay">
                  <h2>
                    {Title}
                    <DotComponent />
                  </h2>

                  <button
                    onClick={closeModal}
                    aria-label={CloseButtonText}
                    css={[styles.closeButtonCss]}
                  >
                    <span>
                      <i css={styles.iconCss} className="icon-closer" />
                    </span>
                    <span>{CloseButtonText}</span>
                  </button>
                </div>

                <Row>
                  {this.getLeftPanel(LeftPanel)}
                  {this.getMiddlePanel(MiddlePanel)}
                  {this.getMiddlePanel(RightPanel)}
                </Row>
              </Column>
            </Row>
          </Container>
        </Modal>
      </React.Fragment>
    );
  }
}

DecisionPoint.displayName = 'Decision Point';

export default compose(
  withNamespaces(),
  withConsumer(ModalsConsumer, 'modalsContext'),
)(DecisionPoint);
